import { GetListParams } from 'react-admin'
import StackAPI from '../../../lib/StackAPI'
import Storage from '../../../lib/Storage'

const urlBuilder = (orgId: string, offset: number, page: number) =>
  `/api/org_users?filter[org_id]=${orgId}&page[offset]=${offset}&page[limit]=${page}`

export const getOrgUsers = async (params: GetListParams) => {
  const { get } = StackAPI()
  const { organizationId: orgId } = Storage().getActiveRole()
  const { pagination } = params

  const offset = (pagination?.page - 1) * pagination?.perPage
  const limit = pagination?.perPage

  const headers = {
    Accept: 'application/vnd.api+json',
    'Content-Type': 'application/vnd.api+json'
  }

  const request = {
    path: urlBuilder(orgId, offset, limit),
    headers
  }

  return await get(request)
    .then(({ data, status }) => (status === 200 ? data : []))
    .catch(() => [])
}
